import { render, staticRenderFns } from "./newsDetails.vue?vue&type=template&id=3b44eada&"
import script from "./newsDetails.vue?vue&type=script&lang=js&"
export * from "./newsDetails.vue?vue&type=script&lang=js&"
import style0 from "./newsDetails.vue?vue&type=style&index=0&id=3b44eada&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports